import { APP_CONSTANTS } from "../../core/config/appConstants";
import Container from "../../shared/components/Container/Container";
import useTitle from "../../core/hooks/useTitle";

const AlreadyAccepted = ({ email }) => {
	useTitle("Bereits verifiziert");
	const buttons = [
		{
			label: "Zu Telekom.de",
			variant: "primary",
			onClick: () =>
				(window.location.href =
					APP_CONSTANTS.LINK.TELEKOM),
			size: "small",
			tabIndex: 2,
			ariaLabel: "Link zu Telekom.de"
		}
	];
	const icons = [
		{
			name: "success-type-standard",
			size: 64,
			color: "var(--color-success)"
		}
	];

	return (
		<Container
			title="Bereits bestätigt"
			description={
				<>
					Vielen Dank, Ihre E-Mail-Adresse {email}{" "}
					ist bereits bestätigt. Ihre Kontaktdaten
					können Sie im{" "}
					<a
						href={
							APP_CONSTANTS.LINK
								.KUNDENCENTER
						}
						className={"link"}
						tabIndex={1}
					>
						Kundencenter
					</a>{" "}
					jederzeit einsehen und ändern.
				</>
			}
			buttons={buttons}
			icon={icons[0]}
		></Container>
	);
};

export default AlreadyAccepted;
